import customAxios from "./axiosConfig";

const TemporaryFileService = {
  download (uuid) {
    const api_url = window.Urls['temporaryfile-download'](uuid);
    return customAxios.get(api_url)
  },
};

export default TemporaryFileService;